import { UseReportResponse } from '../../shared/Forms/hooks/useReport/useReport';
import {
    DataHeader,
} from '../../shared/QSightDataTable/QSightDataTable';
import { UsageTransfer } from '@qsightpbi-integration/sdk';

export interface UsageTransferTableData {
    id: string;
    productInfo: JSX.Element; // Example custom column, replace with actual data structure
    quantity: JSX.Element; // Example quantity, replace with actual data structure
    valuePrice: JSX.Element; // Example value & price, replace with actual data structure
    extraInfo?: JSX.Element | null;
}

export interface UsageTransferTableProps {
    reportState: UseReportResponse<UsageTransfer.Props>;
}

//   This will manage the actual columns that we will output within the table
//   The @dataRef will control which property within the actual object/row corresponds to this column to be output

// TODO: Ensure dataRef matches key of our data object
export const headers: DataHeader<UsageTransferTableData>[] = [
    {
        data: 'Product Info',
        dataRef: 'productInfo',
        sortable: false,
        sortKey: 'productInfo',
        width: '40%'
    },
    {
        data: 'Quantity',
        dataRef: 'quantity',
        sortable: false,
        sortKey: 'quantity',
        width: '20%',
    },
    {
        data: 'Value & Price',
        dataRef: 'valuePrice',
        sortable: false,
        sortKey: 'valuePrice',
        width: '40%'
    },
    // {
    //     data: 'Hospital Group',
    //     dataRef: 'hospitalGroupName',
    //     sortKey: 'hospitalGroupName',
    //     sortable: false
    // },
    // {
    //     data: 'Hospital Name',
    //     dataRef: 'hospitalName',
    //     sortKey: 'hospitalName'
    // },
    // {
    //     data: 'Department Name',
    //     dataRef: 'departmentName',
    //     sortKey: 'departmentName'
    // },
    // {
    //     data: 'Manufacturer Name',
    //     dataRef: 'manufacturerName',
    //     sortKey: 'manufacturerName'
    // },
    // {
    //     data: 'Product Type',
    //     dataRef: 'productType',
    //     sortKey: 'productType'
    // },
    // {
    //     data: 'Catalog Number',
    //     dataRef: 'catalogNo',
    //     sortKey: 'catalogNo'
    // },
    // {
    //     data: 'Month',
    //     dataRef: 'month',
    //     sortKey: 'month'
    // },
    // {
    //     data: 'Year',
    //     dataRef: 'year',
    //     sortKey: 'year'
    // },
];